import React , { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react'
// styles imports
import './FlexibleTextInput.scss';

const FlexibleTextInput = forwardRef((props, ref) => {
	const textareaRef = useRef(null);
	const isTouched = useRef(false);  // useRefで状態を管理
	const [value, setValue] = useState(props.default);

	useImperativeHandle(ref, () => ({
		blur: () => textareaRef.current?.blur()
	}));

	useEffect(() => {
		if (isTouched.current) 
		{
			return
		}

		setValue(props.default)
	
	}, [props.default]);

	useEffect(() => {
		if (props.value === null || props.value === undefined){
			return
		}
		if (textareaRef.current) {
			textareaRef.current.value = props.value; // DOMを直接操作
			setValue(props.value)
			adjustHeight()
		}
	}, [props.value]);

	const handleChange = (e) => {
		setValue(e.target.value);
		props.onchange && props.onchange(e.target.value);
	};

	const handleBlur = (e) => {
		props.onblur && props.onblur(e.target.value);
	};

	const adjustHeight = () => {
		if (! textareaRef.current)
		{
			return
		}
		if (! textareaRef.current.style)
		{
			return
		}

		let offset = 0;
		if (props.offset && props.offset > 0)
		{
			offset = props.offset
		}
		
		// テキストエリアの高さを自動調整
		textareaRef.current.style.height = "auto"; // 初期化
		let newHeight = textareaRef.current.scrollHeight - offset;
		if (props.maxHeight && newHeight > props.maxHeight) {
			newHeight = props.maxHeight;
			textareaRef.current.style.overflowY = "auto";
		} else {
			textareaRef.current.style.overflowY = "hidden";
		}
		if (props.minHeight && newHeight < props.minHeight) {
			newHeight = props.minHeight;
		}
		textareaRef.current.style.height = `${newHeight}px`;
	}

	useEffect(() => {
		adjustHeight()
	}, [props.default, textareaRef]);

	 // コンポーネントの返却
	if (props.isLoading)
	{
		return (
			<div
				/* set */
				id={props.name}
				className={"flexible-textinput loading"}
			>
			</div>
		);
	}

	return (
		<textarea
			id={props.name}
			name={props.name}
			className={"flexible-textinput " + (props.className ? props.className : "")}
			ref={textareaRef}
			value={value}
			onChange={handleChange}
			onBlur={handleBlur}
			defaultValue={props.default ? props.default : ""}
			style={{
				width: "100%",
				overflow: "hidden",
				resize: "none", // 手動リサイズを無効化
				minHeight: "20px",
			}}
			placeholder={props.placeholder ? props.placeholder : ""}
			disabled={props.disabled}
		/>
	);
});
export default FlexibleTextInput
